import { render } from "./IncreaseYourBrands.vue?vue&type=template&id=f3067138&scoped=true&ts=true"
import script from "./IncreaseYourBrands.vue?vue&type=script&lang=ts"
export * from "./IncreaseYourBrands.vue?vue&type=script&lang=ts"

import "./IncreaseYourBrands.vue?vue&type=style&index=0&id=f3067138&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3067138"]])

export default __exports__